/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query'
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type {
  HTTPValidationError,
  ShearAnchorChecksOnElementDTO,
  ShearAnchorConnectorSelectionEditDTO,
} from '../fastAPI.schemas'

/**
 * The checks of the draft location's segment, with the draft selection
for the location and the stored ones elsewhere. Nothing is stored.
 * @summary Post Shear Anchor Check Preview
 */
export const postShearAnchorCheckPreview = (
  projectGuid: string,
  shearAnchorConnectorSelectionEditDTO: ShearAnchorConnectorSelectionEditDTO,
  signal?: AbortSignal,
) => {
  return customInstance<ShearAnchorChecksOnElementDTO>({
    url: `/projects/${projectGuid}/shear-anchor-check-preview`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: shearAnchorConnectorSelectionEditDTO,
    signal,
  })
}

export const usePostShearAnchorCheckPreviewMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postShearAnchorCheckPreview>>,
    TError,
    { projectGuid: string; data: ShearAnchorConnectorSelectionEditDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof postShearAnchorCheckPreview>>,
  TError,
  { projectGuid: string; data: ShearAnchorConnectorSelectionEditDTO },
  TContext
> => {
  const mutationKey = ['postShearAnchorCheckPreview']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postShearAnchorCheckPreview>>,
    { projectGuid: string; data: ShearAnchorConnectorSelectionEditDTO }
  > = props => {
    const { projectGuid, data } = props ?? {}

    return postShearAnchorCheckPreview(projectGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/shear-anchor-check-preview` },
    {
      operationId:
        'post_shear_anchor_check_preview_projects__project_guid__shear_anchor_check_preview_post',
      operationName: 'postShearAnchorCheckPreview',
    },
  )

  return customOptions
}

export type PostShearAnchorCheckPreviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof postShearAnchorCheckPreview>>
>
export type PostShearAnchorCheckPreviewMutationBody = ShearAnchorConnectorSelectionEditDTO
export type PostShearAnchorCheckPreviewMutationError = HTTPValidationError

/**
 * @summary Post Shear Anchor Check Preview
 */
export const usePostShearAnchorCheckPreview = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postShearAnchorCheckPreview>>,
    TError,
    { projectGuid: string; data: ShearAnchorConnectorSelectionEditDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof postShearAnchorCheckPreview>>,
  TError,
  { projectGuid: string; data: ShearAnchorConnectorSelectionEditDTO },
  TContext
> => {
  const mutationOptions = usePostShearAnchorCheckPreviewMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Fix the Schubverbinder of Schubanker locations by hand, or hand them
back to the priority list. Locations not in the body are unchanged.
 * @summary Put Shear Anchor Connector Selections
 */
export const putShearAnchorConnectorSelections = (
  projectGuid: string,
  shearAnchorConnectorSelectionEditDTO: ShearAnchorConnectorSelectionEditDTO[],
) => {
  return customInstance<unknown>({
    url: `/projects/${projectGuid}/shear-anchor-connector-selections`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: shearAnchorConnectorSelectionEditDTO,
  })
}

export const usePutShearAnchorConnectorSelectionsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putShearAnchorConnectorSelections>>,
    TError,
    { projectGuid: string; data: ShearAnchorConnectorSelectionEditDTO[] },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof putShearAnchorConnectorSelections>>,
  TError,
  { projectGuid: string; data: ShearAnchorConnectorSelectionEditDTO[] },
  TContext
> => {
  const mutationKey = ['putShearAnchorConnectorSelections']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putShearAnchorConnectorSelections>>,
    { projectGuid: string; data: ShearAnchorConnectorSelectionEditDTO[] }
  > = props => {
    const { projectGuid, data } = props ?? {}

    return putShearAnchorConnectorSelections(projectGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/shear-anchor-connector-selections` },
    {
      operationId:
        'put_shear_anchor_connector_selections_projects__project_guid__shear_anchor_connector_selections_put',
      operationName: 'putShearAnchorConnectorSelections',
    },
  )

  return customOptions
}

export type PutShearAnchorConnectorSelectionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof putShearAnchorConnectorSelections>>
>
export type PutShearAnchorConnectorSelectionsMutationBody = ShearAnchorConnectorSelectionEditDTO[]
export type PutShearAnchorConnectorSelectionsMutationError = HTTPValidationError

/**
 * @summary Put Shear Anchor Connector Selections
 */
export const usePutShearAnchorConnectorSelections = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putShearAnchorConnectorSelections>>,
    TError,
    { projectGuid: string; data: ShearAnchorConnectorSelectionEditDTO[] },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof putShearAnchorConnectorSelections>>,
  TError,
  { projectGuid: string; data: ShearAnchorConnectorSelectionEditDTO[] },
  TContext
> => {
  const mutationOptions = usePutShearAnchorConnectorSelectionsMutationOptions(options)

  return useMutation(mutationOptions)
}
